import React, { useEffect, useState } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import ExamPaperCard from './ExamPaperCard'
import ExamPaperFooter from './ExamPaperFooter'
import {
  arrowDownIcon,
  arrowUpIcon,
  bookmarkIcon,
  fillFolderIcon,
  leftArrowIcon,
  noFolderIcon,
  refreshIcon,
} from '../../../constants/icons'
import { FaBookmark, FaRegBookmark } from 'react-icons/fa'
import BasicContentLoader from '../../../components/loader/BasicContentLoader'
import ExamPaperTableView from './ExamPaperTableView'
import ExamPaperTableSkeleton from './ExamPaperTableSkeleton'
import { getAllBookmarks } from '../../../api/user/bookmark.api'
import { printMultipleQuestions } from '../../../utils/printQuestions'
import PdfReader from '../../../components/PdfReader'
import { getFileType } from '../../../utils/helper'

const Q_PLACEHOLDER = 'https://placehold.co/320x240?text=Question'
const MS_PLACEHOLDER = 'https://placehold.co/320x240?text=No+scheme'

function BookmarkedComponent({
  selectedPapers,
  setSelectedPapers,
  bookmarkedQuestions,
  setBookmarkedQuestions,
  handleBookmarkClick,
  loading,
  onQuestionCardClick,
  setShowModal,
  setSelectedQuestion,
  setQuestionDetailLoading,
  allBookmarkedIds,
  resultsLayout = 'single',
}) {
  const bookmarksRef = React.useRef(null)
  const [loadMoreLoading, setLoadMoreLoading] = useState(false)
  const [isCollectionOpen, setIsCollectionOpen] = useState(false)
  const [isBookmarkOpen, setIsBookmarkOpen] = useState(true)
  const [printLoading, setPrintLoading] = useState(false)

  const [selectedCollection, setSelectedCollection] = useState(null)
  const [isSelectedCollectionOpen, setIsSelectedCollectionOpen] =
    useState(false)

  const collectionItems = [
    { id: 'collection1', title: 'Algebra 2024', papersCount: 3 },
    { id: 'collection2', title: 'Physics 2021', papersCount: 2 },
    { id: 'collection3', title: 'Irish 2024', papersCount: 5 },
    { id: 'collection4', title: 'French 2020', papersCount: 4 },
    { id: 'collection5', title: 'Maths 2024', papersCount: 8 },
    { id: 'collection6', title: 'Spanish 2024', papersCount: 20 },
    { id: 'collection7', title: 'Geography  2020', papersCount: 6 },
    { id: 'collection8', title: 'Probability 2025', papersCount: 10 },
    { id: 'collection9', title: 'Functions 2025', papersCount: 1 },
  ]
  const bookmarkedItems = bookmarkedQuestions

  const togglePaperSelection = (id, isSelected) => {
    setSelectedPapers((prev) =>
      isSelected ? [...prev, id] : prev.filter((paperId) => paperId !== id),
    )
  }

  const toggleCollectionView = () => {
    if (!selectedCollection) {
      setIsCollectionOpen((prev) => !prev)
    } else {
      setIsSelectedCollectionOpen((prevState) => !prevState)
    }
  }

  const backToCollections = () => {
    setSelectedCollection(null)
    setIsSelectedCollectionOpen(false)
    setIsCollectionOpen(true)
  }

  const handleLoadMore = () => {
    setLoadMoreLoading(true)

    setTimeout(() => {
      setLoadMoreLoading(false)
    }, 2000)
  }

  const handlePrintAllBookmarks = async () => {
    setPrintLoading(true)
    try {
      const response = await getAllBookmarks(1, 1000)

      // Extract questions from bookmark objects
      const allQuestions = response.data
        .map((bookmark) => bookmark.question)
        .filter(Boolean)

      if (allQuestions.length === 0) {
        alert('No bookmarked questions to print.')
        return
      }

      // Print all questions
      await printMultipleQuestions(allQuestions, [], false)
    } catch (error) {
      console.error('Failed to fetch and print bookmarks:', error)
      alert('Failed to print bookmarks. Please try again.')
    } finally {
      setPrintLoading(false)
    }
  }

  useEffect(() => {
    if (bookmarksRef.current) {
      bookmarksRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [bookmarkedQuestions])

  return (
    <div className='bookmark-content'>
      {/* Collection  */}
      {/* <div className='bookmark-accordion-tab'>
        <div
          role='button'
          className='expanded-icon'
          onClick={toggleCollectionView}
        >
          {isCollectionOpen && (!selectedCollection || isSelectedCollectionOpen)
            ? arrowUpIcon
            : arrowDownIcon}
          Collections <span>{collectionItems.length}</span>
        </div>
        {selectedCollection && (
          <Button
            className='back-btn'
            variant='outline-primary'
            onClick={backToCollections}
          >
            {leftArrowIcon}Back to all folders
          </Button>
        )}
      </div>

      {isCollectionOpen && !selectedCollection && (
        <>
          <div className='bookmark-collection-wrapper'>
            {collectionItems.length > 0 ? (
              collectionItems.map((collection) => (
                <div
                  className='collection-subject'
                  key={collection.id}
                  onClick={() => {
                    setSelectedCollection(collection.id)
                    setIsSelectedCollectionOpen(true)
                  }}
                >
                  <div className='icon-wrap'>{fillFolderIcon}</div>
                  <div className='info-wrap'>
                    <h4>{collection.title}</h4>
                    <span>{collection.papersCount} papers</span>
                  </div>
                </div>
              ))
            ) : (
              <div className='bookmark-block-info'>
                <div className='circle-wrap'>{noFolderIcon}</div>
                <p>
                  After you add your bookmarked papers to the collection,
                  they'll show up right here.
                </p>
              </div>
            )}
          </div>
          <span
            role='button'
            className={`load-more-btn py-1 px-4 pb-4 ${
              loadMoreLoading ? "rotate-icon" : ""
            }`}
            onClick={handleLoadMore}
          >
            {refreshIcon} Load more
          </span>
        </>
      )} */}
      {selectedCollection && isSelectedCollectionOpen && (
        <Row>
          {resultsLayout === 'single' ? (
            <Col xl={12} className='mb-4'>
              <div className='filter-content filter-content--table'>
                <ExamPaperTableView
                  questions={bookmarkedQuestions}
                  allBookmarkedIds={allBookmarkedIds}
                  handleBookmarkClick={handleBookmarkClick}
                  handleQuestionClick={onQuestionCardClick}
                />
              </div>
            </Col>
          ) : (
            bookmarkedQuestions.map((question, index) => (
            <Col key={index} xl={12} xxl={6} className='mb-4'>
              <div onClick={() => onQuestionCardClick(question)}>
                <ExamPaperCard
                  id={question._id}
                  title={`Q. ${question.question_number} ${question.part}`}
                  onCheckboxChange={(isSelected) =>
                    togglePaperSelection(question._id, isSelected)
                  }
                  isChecked={selectedPapers.includes(question._id)}
                  bookMarkIconBtn={
                    // fileIcon
                    allBookmarkedIds.has(question._id) ? (
                      <FaBookmark />
                    ) : (
                      <FaRegBookmark />
                    )
                  }
                  onBookmarkClick={(e) =>
                    handleBookmarkClick(e, question, true)
                  }
                  bodyContent={
                    getFileType(question?.question_file) === 'pdf' ? (
                      <PdfReader
                        file={question.question_file}
                        showFullScreenButton={false}
                      />
                    ) : (
                      <img
                        src={question.question_file || Q_PLACEHOLDER}
                        alt={`Question ${question.question_number}`}
                        style={{
                          width: 'auto',
                          maxWidth: '100%',
                          height: 'auto',
                          objectFit: 'contain',
                          display: 'block',
                        }}
                        onError={(e) => {
                          e.target.onerror = null
                          e.target.src = Q_PLACEHOLDER
                        }}
                      />
                    )
                  }
                  footerContent={
                    <ExamPaperFooter
                      subject={question.topics[0]?.title}
                      paper={question.paper}
                      year={question.year}
                      markingSchemeContent={
                        getFileType(question?.ms_file) === 'pdf' ? (
                          <PdfReader
                            file={question.ms_file}
                            showFullScreenButton={false}
                          />
                        ) : (
                          <img
                            src={question.ms_file || MS_PLACEHOLDER}
                            alt={`Question ${question.question_number}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                            }}
                            onError={(e) => {
                              e.target.onerror = null
                              e.target.src = MS_PLACEHOLDER
                            }}
                          />
                        )
                      }
                    />
                  }
                />
              </div>
            </Col>
            ))
          )}
        </Row>
      )}

      <div className='bookmark-accordion-tab' ref={bookmarksRef}>
        <div
          role='button'
          className='expanded-icon'
          onClick={() => setIsBookmarkOpen(!isBookmarkOpen)}
        >
          {isBookmarkOpen ? arrowUpIcon : arrowDownIcon} Bookmarks{' '}
          <span>{bookmarkedItems.length}</span>
        </div>
        <Button
          variant='primary'
          size='sm'
          onClick={handlePrintAllBookmarks}
          disabled={printLoading || bookmarkedItems.length === 0}
          className='ms-auto'
        >
          {printLoading ? (
            <>
              <span
                className='spinner-border spinner-border-sm me-2'
                role='status'
                aria-hidden='true'
              ></span>
              Printing...
            </>
          ) : (
            'Print All Bookmarks'
          )}
        </Button>
      </div>

      {isBookmarkOpen &&
        (loading ? (
          resultsLayout === 'single' ? (
            <ExamPaperTableSkeleton rows={6} />
          ) : (
            <Row>
              {[1, 2, 3, 4].map((_, index) => (
                <Col key={index} xl={12} xxl={6} className='mb-4'>
                  <BasicContentLoader />
                </Col>
              ))}
            </Row>
          )
        ) : resultsLayout === 'single' ? (
          <div className='filter-content filter-content--table'>
            <ExamPaperTableView
              questions={bookmarkedQuestions}
              allBookmarkedIds={allBookmarkedIds}
              handleBookmarkClick={handleBookmarkClick}
              handleQuestionClick={onQuestionCardClick}
            />
          </div>
        ) : (
          <Row>
            {bookmarkedQuestions.map((question, index) => (
              <Col key={question._id} xl={12} xxl={6} className='mb-4'>
                <div onClick={() => onQuestionCardClick(question)}>
                  <ExamPaperCard
                    id={question._id}
                    title={`Q. ${question.question_number} ${question.part}`}
                    onCheckboxChange={(isSelected) =>
                      togglePaperSelection(question._id, isSelected)
                    }
                    isChecked={selectedPapers.includes(question._id)}
                    bookMarkIconBtn={
                      allBookmarkedIds.has(question._id) ? (
                        <FaBookmark />
                      ) : (
                        <FaRegBookmark />
                      )
                    }
                    onBookmarkClick={(e) =>
                      handleBookmarkClick(e, question, true)
                    }
                    bodyContent={
                      getFileType(question?.question_file) === 'pdf' ? (
                        <PdfReader
                          file={question.question_file}
                          showFullScreenButton={false}
                        />
                      ) : (
                        <img
                          src={question.question_file || Q_PLACEHOLDER}
                          alt={`Question ${question.question_number}`}
                          style={{
                            width: 'auto',
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            display: 'block',
                          }}
                          onError={(e) => {
                            e.target.onerror = null
                            e.target.src = Q_PLACEHOLDER
                          }}
                        />
                      )
                    }
                    footerContent={
                      <ExamPaperFooter
                        subject={question.topics[0]?.title}
                        paper={question.paper}
                        year={question.year}
                        markingSchemeContent={
                          getFileType(question?.ms_file) === 'pdf' ? (
                            <PdfReader
                              file={question.ms_file}
                              showFullScreenButton={false}
                            />
                          ) : (
                            <img
                              src={question.ms_file || MS_PLACEHOLDER}
                              alt={`Question ${question.question_number}`}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                              }}
                              onError={(e) => {
                                e.target.onerror = null
                                e.target.src = MS_PLACEHOLDER
                              }}
                            />
                          )
                        }
                      />
                    }
                  />
                </div>
              </Col>
            ))}
          </Row>
        )
      )}
    </div>
  )
}

export default BookmarkedComponent
